<template>
  <div class="report-page">
      <div class="report-card" style="padding: 20px;">
        <div class="report-header pdf-avoid-break">
        <div class="header-row-1">
          <img class="brand-logo" :src="brandLogo" alt="易宝品牌" />
          <h1>面试评估报告</h1>
        </div>
        <div class="header-row-2 sub">易宝视频面试平台 · AI监控+面试官评价+复核结论</div>
        <div class="header-row-3">
          <span class="meta-item" style="margin-right: 12px;">报告编号：<strong>{{ basic.report_number || "" }}</strong></span>
          <span class="meta-item">生成时间 <strong>{{ basic.generated_at || "" }}</strong></span>
        </div>
      </div>

      <div class="info-strip pdf-avoid-break">
        <table style="width: 100%; border-collapse: collapse">
          <tr>
            <td class="info-cell" style="width: 30%">
              <span class="label">候选人</span>
              <span class="value">{{ basic.candidate_name || "" }}</span>
            </td>
            <td class="info-cell" style="width: 40%">
              <span class="label">联系方式</span>
              <span class="value">{{ basic.phone_masked || "" }}</span>
            </td>
            <td class="info-cell" style="width: 30%">
              <span class="label">应聘岗位</span>
              <span class="value">{{ basic.position || "" }}</span>
            </td>
          </tr>
          <tr>
            <td class="info-cell">
              <span class="label">面试官</span>
              <span class="value">{{ basic.interviewer_name || "待指定" }}</span>
            </td>
            <td class="info-cell">
              <span class="label">面试时间</span>
              <span class="value">{{ basic.interview_time || "未知" }}</span>
            </td>
            <td class="info-cell">
              <span class="label">面试方式</span>
              <span class="value">视频面试</span>
            </td>
          </tr>
        </table>
      </div>

      <div class="report-sections">
        <section class="section">
          <div class="section-header" style="padding-bottom: 0;">
            <h2>AI 专业评估报告 · 行为监控与风险</h2>
            <span class="pill-right" style="color:#6b7280;">基于视频/音频/屏幕行为分析</span>
          </div>
          <div class="section-body" style="padding-top: 0;">
            <div v-if="hasAiEval" class="ai-summary pdf-avoid-break">
              <p style="font-size: 14px;font-weight: 500;"><strong>综合评估：</strong>{{ aiEval.comprehensive_evaluation }}</p>
            </div>
            <div v-else class="ai-pending"><strong>综合评估：</strong>AI 分析中，请稍后查看。</div>

            <table v-if="hasAiEval && aiDimensionRows.length" class="pdf-avoid-break" style="width: 100%; border-collapse: separate; margin: 10px 0 12px">
              <tr v-for="(pair, rowIdx) in aiDimensionRows" :key="`ai-dimension-row-${rowIdx}`">
                <td style="width: 50%; vertical-align: top; padding-right: 6px;border-bottom:none;padding-left: 0px;" :style="rowIdx > 0 ? { paddingTop: '10px' } : null">
                  <div v-if="pair[0]" class="dimension-item">
                    <div class="dimension-label">{{ pair[0].label }}（分）</div>
                    <div class="dimension-score"><span class="score-number">{{ pair[0].score }}</span></div>
                    <div class="progress-bar"><div class="progress-fill" :style="{ width: `${scorePercent(pair[0].score)}%` }" /></div>
                  </div>
                </td>
                <td style="width: 50%; vertical-align: top; padding-left: 6px;border-bottom:none;padding-right: 0px;" :style="rowIdx > 0 ? { paddingTop: '10px' } : null">
                  <div v-if="pair[1]" class="dimension-item">
                    <div class="dimension-label">{{ pair[1].label }}（分）</div>
                    <div class="dimension-score"><span class="score-number">{{ pair[1].score }}</span></div>
                    <div class="progress-bar"><div class="progress-fill" :style="{ width: `${scorePercent(pair[1].score)}%` }" /></div>
                  </div>
                </td>
              </tr>
            </table>


            <div class="section-header" style="padding-bottom: 0;">
              <h2>音视频行为监控</h2>
              <span class="pill-right" style="color:#6b7280;">异常次数统计</span>
            </div>

            <table v-if="behaviorRows.length" class="behaviour-table pdf-avoid-break" style="margin-bottom:25px;">
              <thead>
                <tr><th style="text-align: left; padding-left: 16px">监控项</th><th>次数（次）</th><th>行为风险分数（分）</th><th>权重</th></tr>
              </thead>
              <tbody>
                <tr v-for="(row, idx) in behaviorRows" :key="`behavior-${idx}`">
                  <td>{{ row.name }}</td>
                  <td>{{ row.count }}</td>
                  <td>{{ row.risk_score_total }}</td>
                  <td>{{ row.weight_label }}</td>
                </tr>
              </tbody>
            </table>
            <div v-else style="color: #94a3b8; font-size: 13px; padding: 8px 0 12px">暂无行为异常记录</div>

            <table class="pdf-avoid-break" style="width: 100%; border-collapse: collapse; background: #f3f6fa; border-radius: 12px; margin: 12px 0 8px;margin-bottom:25px;">
              <tr>
                <td style="padding: 12px 16px; vertical-align: middle; width: 38%">
                  <div style="font-size: 12px; color: #64748b; margin-bottom: 2px">风险总分</div>
                  <span style="font-size: 42px; font-weight: 700; color: #1e293b; line-height: 1">{{ aiBehavior.total_risk_score || 0 }}</span>
                  <span style="font-size: 12px; color: #64748b; margin-left: 6px">分</span>
                </td>
                <td style="padding: 12px 16px; vertical-align: middle; width: 28%; text-align: center; border-left: 1px solid #e2e8f0; border-right: 1px solid #e2e8f0">
                  <div style="font-size: 12px; color: #334155; margin-bottom: 8px">风险等级</div>
                  <span :class="['risk-level', aiBehavior.risk_level_class || 'risk-mid']">{{ aiBehavior.risk_level || "" }}</span>
                </td>
                <td style="padding: 12px 16px; vertical-align: middle; width: 34%; font-size: 12px; color: #62748c; line-height: 1.6">{{ aiBehavior.risk_desc || "" }}</td>
              </tr>
            </table>

            <div v-if="aiBehavior.ai_detection_summary" class="pdf-avoid-break" style="background: #f1f5f9; border-radius: 14px; padding: 14px 18px; font-size: 13px; color: #334155; line-height: 1.6; ">
              <strong>AI 检测分析：</strong>{{ aiBehavior.ai_detection_summary }}
            </div>
          </div>
        </section>

        <section class="section">
          <div class="section-header">
            <h2>面试官评价</h2>
            <div class="header-right">
              <span >面试结果：</span>
              <span
                v-if="evaluation.evaluation_result !== null && evaluation.evaluation_result !== undefined"
                :class="['result-badge', Number(evaluation.evaluation_result) === 1 ? 'pass' : 'fail']"
              >
                {{ Number(evaluation.evaluation_result) === 1 ? "通过" : "淘汰" }}
              </span>
            </div>
          </div>
          <div class="section-body">
            <div v-if="hasEvaluation">
              <div class="pdf-avoid-break" style="border-radius: 12px; overflow: hidden; border: 1px solid #e2e8f0">
                <table style="width: 100%; border-collapse: collapse">
                  <tr>
                    <td class="score-card">
                      <div class="score-card-label">技能匹配度</div>
                      <span class="score-card-num">{{ intOrDash(evaluation.skill_match) }}</span>
                    </td>
                    <td class="score-card">
                      <div class="score-card-label">沟通表达</div>
                      <span class="score-card-num">{{ intOrDash(evaluation.communication) }}</span>
                    </td>
                    <td class="score-card">
                      <div class="score-card-label">解决问题</div>
                      <span class="score-card-num">{{ intOrDash(evaluation.problem_solving) }}</span>
                    </td>
                    <td class="score-card">
                      <div class="score-card-label">工作思路</div>
                      <span class="score-card-num">{{ intOrDash(evaluation.work_thought) }}</span>
                    </td>
                    <td class="score-card">
                      <div class="score-card-label">技术基础</div>
                      <span class="score-card-num">{{ intOrDash(evaluation.technical_basis) }}</span>
                    </td>
                    <td class="score-card score-card-total" style="border-right: 1px solid #2563eb">
                      <div class="score-card-label">综合得分</div>
                      <span class="score-card-num">{{ intOrDash(evaluation.comprehensive_score) }}</span>
                    </td>
                  </tr>
                </table>
              </div>

              <div class="comment-full pdf-avoid-break">
                <div class="interviewer-meta">
                  <span style="font-weight: 600; font-size: 16px; vertical-align: middle">{{ basic.interviewer_name || "面试官" }} · 综合评价</span>
                </div>
                <div v-if="evaluation.text_evaluation" class="comment-box">{{ evaluation.text_evaluation }}</div>
                <div v-else class="comment-box" style="color: #94a3b8">（暂无文字评语）</div>
              </div>
            </div>
            <div v-else class="eval-pending">面试官评价待填写</div>
          </div>
        </section>

        <section class="section">
          <div class="section-header">
            <h2>复核结论</h2>
            <span class="pill-right" style="color:#6b7280;">招聘负责人</span>
          </div>
          <div class="section-body">
            <div v-if="hasReview">
              <div class="review-conclusion pdf-avoid-break">
                <table style="width: 100%; border-collapse: collapse; margin-bottom: 16px">
                  <tr>
                    <td style="vertical-align: middle">
                      <div :class="['final-result', reviewConclusionClass]">{{ reviewConclusionText }}</div>
                    </td>
                    <td style="vertical-align: middle; text-align: right; font-size: 13px; color: #475569">
                      复核人：<strong>{{ hrReview.reviewer_name || "" }}</strong>
                      <span style="margin-left: 12px; color: #94a3b8">{{ hrReview.review_time || "" }}</span>
                    </td>
                  </tr>
                </table>
                <div v-if="hrReview.review_remarks" class="review-message">{{ hrReview.review_remarks }}</div>
                <div class="review-footer">
                  <span>复核依据: 面试录像回放、AI行为监控分析、面试官评价</span>
                </div>
              </div>
            </div>
            <div v-else class="review-placeholder">
              <div class="review-placeholder-text">复核结论待 HR 填写</div>
            </div>
          </div>
        </section>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: "InterviewAssessmentReportPreview",
  data() {
    return {
      brandLogo: require("@/assets/brand-logo.png"),
    };
  },
  props: {
    reportData: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    reportSource() {
      return this.reportData || {};
    },
    basic() {
      return (this.reportSource && this.reportSource.basic_info) || {};
    },
    aiBehavior() {
      return (this.reportSource && this.reportSource.ai_behavior) || {};
    },
    behaviorRows() {
      return Array.isArray(this.aiBehavior.behavior_rows) ? this.aiBehavior.behavior_rows : [];
    },
    aiEval() {
      return (this.reportSource && this.reportSource.ai_evaluation) || {};
    },
    hasAiEval() {
      return !!(this.aiEval && this.aiEval.comprehensive_evaluation);
    },
    aiDimensionRows() {
      const scores = (this.aiEval && this.aiEval.dimension_scores) || {};
      if (!scores || typeof scores !== "object") return [];

      const order =
        (this.aiEval && (this.aiEval.dimension_scores_order || this.aiEval.dimension_score_order)) || null;

      const entries = [];
      if (Array.isArray(order) && order.length) {
        order.forEach((label) => {
          const safeLabel = String(label || "");
          if (!safeLabel) return;
          if (!Object.prototype.hasOwnProperty.call(scores, safeLabel)) return;
          entries.push({ label: safeLabel, score: this.toNumberOrZero(scores[safeLabel]) });
        });
      } else {
        // 按对象自身的字段遍历顺序展示
        // eslint-disable-next-line no-restricted-syntax
        for (const label in scores) {
          if (!Object.prototype.hasOwnProperty.call(scores, label)) continue;
          const safeLabel = String(label || "");
          if (!safeLabel) continue;
          entries.push({ label: safeLabel, score: this.toNumberOrZero(scores[label]) });
        }
      }

      const rows = [];
      for (let i = 0; i < entries.length; i += 2) {
        rows.push([entries[i] || null, entries[i + 1] || null]);
      }
      return rows;
    },
    evaluation() {
      return (this.reportSource && this.reportSource.interviewer_evaluation) || {};
    },
    hasEvaluation() {
      const e = this.evaluation || {};
      return (
        e.skill_match != null ||
        e.communication != null ||
        e.problem_solving != null ||
        e.work_thought != null ||
        e.technical_basis != null ||
        e.comprehensive_score != null ||
        !!String(e.text_evaluation || "").trim()
      );
    },
    interviewerInitial() {
      const name = String(this.basic.interviewer_name || "").trim();
      return name ? name.slice(0, 1) : "?";
    },
    hrReview() {
      return (this.reportSource && this.reportSource.hr_review) || {};
    },
    hasReview() {
      return !!this.hrReview.has_review;
    },
    reviewConclusionText() {
      return this.hrReview.review_conclusion_text || "待定";
    },
    reviewConclusionClass() {
      const cls = String(this.hrReview.review_conclusion_class || "");
      if (cls.includes("pass")) return "pass";
      if (cls.includes("fail")) return "fail";
      return "";
    },
  },
  methods: {
    intOrDash(v) {
      const n = Number(v);
      return Number.isFinite(n) ? Math.round(n) : "—";
    },
    toNumberOrZero(v) {
      const n = Number(v);
      return Number.isFinite(n) ? n : 0;
    },
    aiScore(key) {
      const scores = (this.aiEval && this.aiEval.dimension_scores) || {};
      const n = Number(scores[key]);
      return Number.isFinite(n) ? n : 0;
    },
    aiScorePercent(key) {
      const v = this.aiScore(key);
      if (v < 0) return 0;
      if (v > 100) return 100;
      return v;
    },
    scorePercent(score) {
      const v = this.toNumberOrZero(score);
      if (v < 0) return 0;
      if (v > 100) return 100;
      return v;
    },
    tagClass(item) {
      if (item && item.type === "concern") return "tag concern";
      return "tag highlight";
    },
    tagLabel(item) {
      if (!item) return "";
      if (item.type === "strength") return `[优] ${item.text || ""}`;
      if (item.type === "potential") return `[潜] ${item.text || ""}`;
      return `[注] ${item.text || ""}`;
    },
  },
};
</script>

<style scoped>
.report-page { background: #f3f4f6; padding: 20px 10px; color: #1f2937; }
.report-card { max-width: 790px; margin: 0 auto; width: 100%; background: #fff; border-radius: 8px; overflow: hidden; border: 1px solid #e5e7eb; }
.report-header { background: #fff; padding-left: 0px; padding-right: 0px;}
.header-row-1 { display: flex; align-items: center; gap: 8px; }
.header-row-1 h1 { font-size: 26px; font-weight: 500; letter-spacing: 0; color: #1f2937; line-height: 1; margin: 0; }
.header-row-2 { font-size: 18px; color: #6b7280; margin-top: 8px; font-weight: 500; }
.header-row-3 { margin-top: 6px; display: flex; justify-content: flex-start; align-items: center; gap: 24px; margin-bottom: 20px;}
.brand-logo { width: 100px; height: auto; display: inline-block; vertical-align: middle; }
.meta-item { font-size: 16px; color: #6b7280; white-space: nowrap; }
.meta-item strong { color: #4b5563; font-weight: 600; }
.info-strip { background: #f8fafc;  border-radius: 8px; padding: 16px 32px; font-size: 12px; }
.info-cell { padding: 6px 10px 6px 0; vertical-align: top; border-bottom: none;}
.info-cell .label { font-size: 16px; color: #64748b; display: inline-block; margin-right: 16px; }
.info-cell .value { color: #111827; font-size: 16px; }
.report-sections { display: block; }
.report-sections .section { margin-bottom: 12px; }
.report-sections .section:last-child { margin-bottom: 0; }
.section { border-radius: 8px; background: #fff;  }
.section-header { background: #fff;  display: flex; align-items: center; }
.section-header .icon { width: 24px; height: 24px; background: #eef2ff; border-radius: 50%; display: inline-flex; align-items: center; justify-content: center; line-height: 1; font-size: 12px; color: #2563eb; margin-right: 8px; font-weight: 700; }
.icon-green { background: #e7f8ef !important; color: #0f8c4c !important; }
.icon-orange { background: #fff3e8 !important; color: #dd6b20 !important; }
.section-header h2 { font-size: 24px; font-weight: 700; color: #111827; line-height: 1; }
.section-header .pill { margin-left: 10px; background: #f1f5f9; border-radius: 16px; padding: 2px 10px; font-size: 11px; font-weight: 500; color: #64748b; border: 1px solid #e2e8f0; }
.section-header .pill-right { margin-left: auto; }
.header-right { margin-left: auto; display: inline-flex; align-items: center; gap: 8px; }
.result-badge { 
  border-radius: 18px; font-size: 12px; font-weight: 600; border: 1px solid transparent; 
  display: inline-block; width: 54px; text-align: center;height: 27px; line-height: 27px;
}
.result-badge.pass { color: #0d9f4f; background: #e9f9ee; border-color: #bde7c8; }
.result-badge.fail { color: #dc2626; background: #fef2f2; border-color: #fecaca; }
.ai-summary { background: #f8fafc; border-radius: 8px; padding: 10px 12px; margin-bottom: 10px;  }
.ai-summary p { font-size: 12px; line-height: 1.55; color: #334155; margin-bottom: 8px; }
.ai-pending { background: #f8fafc; border-radius: 8px; padding: 10px 12px; margin-bottom: 10px;  color: #64748b; font-size: 12px; }
.tag-group { margin-top: 6px; }
.tag { background: #fff; border: 1px solid #d9e2ec; border-radius: 16px; padding: 3px 10px; font-size: 11px; color: #475569; display: inline-block; margin: 0 6px 6px 0; }
.tag.highlight { background: #eaf2ff; border-color: #c3d8ff; color: #1d4ed8; font-weight: 600; }
.tag.concern { background: #fff7ed; border-color: #fed7aa; color: #c2410c; }
.dimension-item { background: #fff; border-radius: 8px; padding: 9px 11px; border: 1px solid #e8eef5; width: 100%; }
.dimension-label { font-size: 12px; color: #64748b; margin-bottom: 4px; }
.score-number { font-size: 34px; font-weight: 700; color: #0f172a; line-height: 1; }
.progress-bar { height: 4px; background: #e2e8f0; border-radius: 20px; width: 100%; margin: 6px 0 0; overflow: hidden; }
.progress-fill { height: 100%; background: #3b82f6; border-radius: 20px; }
.behaviour-table { width: 100%; border-collapse: collapse; font-size: 12px; margin: 10px 0 8px; }
.behaviour-table th { background: #f1f5f9; color: #334155; font-weight: 600; padding: 8px 6px; font-size: 12px; text-align: center; border-bottom: 1px solid #dbe5f1; }
.behaviour-table td { padding: 8px 6px; border-bottom: 1px solid #edf2f7; text-align: center; background: #fff; }
.behaviour-table tbody tr:nth-child(even) td { background: #f8fafc; }
.behaviour-table tr:last-child td { border-bottom: none; }
.behaviour-table td:first-child { font-weight: 500; color: #0f172a; text-align: left; padding-left: 12px; }
.risk-level { display: inline-block; vertical-align: middle; padding: 4px 12px; border-radius: 14px; font-weight: 600; font-size: 14px; background: #fff; border: 1px solid; }
.risk-low { background: #e6f7e6; color: #2e7d32; border-color: #a5d6a5; }
.risk-mid { background: #fff4e5; color: #b76e1c; border-color: #ffd599; }
.risk-high { background: #ffebee; color: #b71c1c; border-color: #ffb3b3; }
.score-card { text-align: center; padding: 11px 8px; background: #f8fafc; border-right: 1px solid #e2e8f0; vertical-align: middle; }
.score-card-label { font-size: 12px; color: #64748b; font-weight: 500; margin-bottom: 8px; }
.score-card-num { font-size: 34px; font-weight: 600; color: #2563eb; line-height: 1; }
.score-card-total { background: #2563eb; }
.score-card-total .score-card-label { color: rgba(255, 255, 255, 0.85); }
.score-card-total .score-card-num { color: #fff; }
.comment-full { background: #f8fafc; border-radius: 8px; padding: 20px; border: 1px solid #e8eef5; margin-top: 16px; }
.interviewer-meta { margin-bottom: 8px; }
.interviewer-avatar { width: 24px; height: 24px; background: #dbeafe; border-radius: 50%; display: inline-block; text-align: center; line-height: 24px; font-size: 12px; font-weight: 700; color: #2563eb; margin-right: 8px; vertical-align: middle; }
.comment-box { background: #fff; border-radius: 8px; padding: 10px 12px; border: 1px solid #e2e8f0; font-size: 14px; line-height: 1.6; color: #1f2a41; white-space: pre-line; }
.eval-pending { background: #f8fafc; border-radius: 8px; padding: 16px; text-align: center; color: #94a3b8; font-size: 13px; border: 1px dashed #dbe4ee; }
.review-conclusion { background: #f8fafc; border-radius: 8px; padding: 12px 14px; border: 1px solid #e5edf5; }
.final-result { display: inline-block;width: 62px;height:34px;line-height: 34px;text-align: center; border-radius: 16px; font-weight: 700; font-size: 16px; background: #fff; border: 1px solid #d9e2ef; display: inline-block; vertical-align: middle; margin-right: 10px; }
.final-result.pass { color: #22c55e; border-color: rgba(34, 197, 94, 0.25); background: #f0fdf4; }
.final-result.fail { color: #ef4444; border-color: rgba(239, 68, 68, 0.25); background: #fef2f2; }
.review-message { background: #fff; border-radius: 8px; padding: 12px; border:1px solid rgb(226, 232, 240); font-size: 13px; line-height: 1.7; color: #1e293b; margin: 6px 0 4px; white-space: pre-line; }
.review-footer { display: flex; justify-content: space-between; align-items: center; margin-top: 10px; color: #64748b; font-size: 11px; }
.review-placeholder { border: 1px solid #eef2f7; border-radius: 8px; padding: 22px 14px; text-align: center; background: #f8fafc; }
.review-placeholder-badge { display: inline-block; padding: 3px 10px; border-radius: 14px; background: #f3f4f6; color: #94a3b8; font-size: 11px; margin-bottom: 14px; }
.review-placeholder-text { font-size: 13px; color: #9ca3af; font-weight: 600; }
.footer-print { padding: 8px 12px 12px; border-top: 1px solid #eef2f6; overflow: hidden; color: #9ca3af; font-size: 11px; }
.footer-print span:first-child { float: left; }
.footer-print span:last-child { float: right; }
.td { border-bottom: none !important; }

/* PDF 导出分页：尽量在模块间分页，避免在模块内部截断 */
.pdf-avoid-break {
  page-break-inside: avoid;
  break-inside: avoid;
}
</style>
